import React from "react"

const DragonSkull = ({
  colors = [
    "#B5B5AE",
    "#SVGID_",
    "#BF0A00",
    "#E59572",
    "#FFF4BF",
    "#FFF7D2",
    "#FFFBE6",
    "#FFFDF4",
    "#FFFFFD",
    "#FFFFFF",
    "#E7A4A0"
  ]
}) => {
  return (
    <g id="DragonSkull">
      <ellipse
        opacity="0.3"
        fill="#21376C"
        cx="68.379"
        cy="52.453"
        rx="6.209"
        ry="2.941"
      />
      <path
        opacity="0.3"
        fill="#21376C"
        d="M75.7316284,52.616581l-14.2974892-0.0817032 l0.8986969,2.1241989c0,0.4901962-0.0816956,1.1437988,0.0816994,1.6339989 c0.0816994-0.6535988,0.6535988-1.3071976,1.0620995-1.6339989h0.2450981 c-0.0816994,0.3268013-0.0816994,0.9804001,0.1634026,1.3888969c0-0.2450981,0.2450981-0.6535988,0.4084969-0.8986969 c0.0817032,0.0816994,0.1633987,0.1633987,0.2451019,0.1633987c0,0.3268013,0.0816956,0.6536026,0.2451019,0.8987007 l0.2451019-0.5718994c0.0816956,0.0816956,0.1633987,0.1633987,0.2451019,0.1633987c0,0.6535988,0,1.4706001,0.2451019,2.0424995 c0.0816956-0.6535988,0.4901962-1.1438026,0.7352982-1.3071976h0.0816956c0,0,0.0816956,0.0816994,0.0816956,0.1633987 c0,0.4902,0.0817032,1.4706001,0.4085007,1.7974014c0-0.3268013,0.1633987-0.735302,0.3268051-0.9804001h2.3693008 c0.1633911,0.2450981,0.3267975,0.6535988,0.3267975,0.9804001c0.3267975-0.2451019,0.4085007-1.225502,0.4085007-1.7156982 c0.0816956-0.0816994,0.1633987-0.1634026,0.1633987-0.1634026l0,0c0.2451019,0.2451019,0.6536026,0.6535988,0.7352982,1.3071976 c0.2451019-0.5718994,0.2451019-1.3888969,0.2451019-2.0424957c0.0817032-0.0816994,0.1633987-0.1634026,0.3268051-0.2451019 l0.2451019,0.4902c0.1633911-0.2450981,0.2451019-0.5718994,0.2451019-0.8170013 c0.0816956-0.0816956,0.2451019-0.1633987,0.3267975-0.2450981c0.1633987,0.2450981,0.4085007,0.6535988,0.4085007,0.8987007 c0.2451019-0.4085007,0.2451019-0.8987007,0.2451019-1.3072014c0.0816956,0,0.0816956-0.0816956,0.1633987-0.0816956h0.0816956 c0.3268051,0.3268013,0.9804001,0.9804001,1.0621033,1.6339989c0.1633987-0.4902,0.1633987-1.1438026,0.0816956-1.6339989 L75.7316284,52.616581z"
      />
      <path
        fill={colors[0]}
        d="M76.385231,52.7799797l-1.7973938-1.2254982c0,0,1.879097-3.2679977,1.1437988-3.2679977 c-1.4706039,0.1634026-1.9608002-0.8169975-2.4509964-1.6339989c-0.0817032-0.0816994-0.0817032-0.2450981-0.1633987-0.3268013 c-0.4085007-0.8169975-0.2451019-2.5326958-0.2451019-2.5326958l-1.225502,0.9804001 c-0.9803925-0.8170013-2.1241989-0.0816994-2.532692-0.1634026l-0.7353058-2.5326958l-0.8170013,2.5326958 c-0.408493,0.0816994-1.4705963-0.7352982-2.4509964,0.1634026l-1.1437988-0.9804001c0,0,0.2451019,1.6339989-0.1633987,2.3693008 c-0.1634026,0.2450981-0.3268013,0.4901962-0.3268013,0.6535988c-0.2451019,0.8986969-0.5719032,1.879097-2.3693008,1.879097 c-0.4902,0,1.1437988,2.8594971,1.1437988,2.8594971l-1.7973976,1.2254982h1.7973976 c0,0.3268013-0.0816994,0.735302,0.0816956,1.0620995c0.0816994-0.4085007,0.6535988-0.8170013,1.0620995-1.0620995h0.2450981 c-0.0816956,0.2450981-0.0816956,0.5718994,0.1634026,0.8987007c0-0.1634026,0.2451019-0.4085007,0.4085007-0.5719032 c0.0816956,0,0.1633987,0.0816994,0.2450943,0.1634026c0,0.1633987,0.0817032,0.4085007,0.2451019,0.5718994l0.2451019-0.3268013 c0.0816956,0.0816994,0.1633987,0.0816994,0.2451019,0.1634026c0,0.4084969,0,0.8986969,0.2451019,1.3071976 c0.0816956-0.4085007,0.4901962-0.735302,0.7352982-0.8170013h0.0817032c0,0,0.0816956,0,0.0816956,0.0816994 c0,0.3268013,0.0816956,0.8986969,0.4085007,1.1437988c0-0.2450981,0.1633987-0.4901962,0.3267975-0.6535988h2.3693008 c0.1633987,0.1634026,0.3268051,0.4085007,0.3268051,0.6535988c0.3267975-0.1633987,0.408493-0.7352982,0.408493-1.0620956 c0.0817032-0.0816994,0.1633987-0.0816994,0.1633987-0.0816994l0,0c0.2451019,0.1633987,0.6536026,0.4084969,0.7353058,0.8169975 c0.2451019-0.3268013,0.2451019-0.8986969,0.2451019-1.2254982c0.0816956-0.0816994,0.1633987-0.0816994,0.3267975-0.1633987 l0.2451019,0.3267975c0.1633987-0.1633987,0.2451019-0.3267975,0.2451019-0.4901962 c0.0817032-0.0816994,0.2451019-0.0816994,0.3268051-0.1634026c0.1633987,0.1634026,0.4085007,0.4085007,0.4085007,0.5719032 c0.2451019-0.2451019,0.2451019-0.5719032,0.2451019-0.8170013c0.0816956,0,0.0816956-0.0816994,0.1633911-0.0816994h0.0817032 c0.3267975,0.2451019,0.9803925,0.6535988,1.0621033,1.0620995c0.1633911-0.3268013,0.1633911-0.735302,0.0816956-1.0620995 h1.8791046v-0.2451019H76.385231z"
      />
      <path
        fill="url(#SVGID_6_)"
        d="M74.5061264,50.2472801c0-0.0816994-0.2451019,0.3268013-0.408493,0.8170013 c-0.0817032-0.3268013-0.3268051-0.4902-0.3268051-0.3268013c0,0.0816994,0,0.6535988,0,0.7352982 c0,0.1634026-0.1633987-0.7352982-0.1633987-0.4901962c-0.0816956,0-0.2451019,0.1633987-0.3267975,0.2450981 c-0.0817032,0.0816994,0,0.6535988-0.0817032,0.6535988c-0.0816956,0-0.0816956-0.4085007-0.1633911-0.4901962 c-0.1633987,0-0.4085007,0.0816956-0.4085007,0.0816956c-0.0817032,0-0.0817032,0.4085007-0.0817032,1.0620995 c-0.0816956,0-0.1633987-0.735302-0.3267975-0.8986969c-0.1633987,0-0.2451019,0-0.4085007-0.0816994 c-0.1633987,0-0.3267975-0.0816994-0.3267975,0c0,0,0.1633911,0.8986969,0.0816956,0.8986969 s-0.1633987-0.7352982-0.4085007-0.8986969c-0.2451019,0.0816994-0.6536026,0-0.6536026,0l-0.1633987,1.0620995 l-0.1633987-1.1438026c0,0-0.1633911-0.0816956-0.408493-0.1633987c-0.1633987-0.0816994-0.2451019,1.2254982-0.3268051,1.1437988 c-0.2451019-0.0816994-0.6536026-1.2254982-0.7352982-1.5522995c0-0.0816994,0-0.1633987,0-0.1633987 s-0.4901962,1.6339989-0.8170013,1.6339989c-0.0816956,0-0.1633987-1.225502-0.3267975-1.1438026 c-0.2451019,0.0816994-0.4085007,0.1634026-0.4085007,0.1634026l-0.1633987,1.1437988l-0.1633987-1.0620995 c0,0-0.4085007,0-0.6536026,0c-0.1633987,0.1634026-0.2451019,0.8987007-0.4085007,0.8987007 c-0.0816956,0,0.0817032-0.8987007,0.0817032-0.8987007s-0.1633987,0-0.3268051,0c-0.1633987,0-0.2451019,0-0.4085007,0.0816994 c-0.1633911,0.1634026-0.2451019,0.8986969-0.3267975,0.8986969c0-0.6535988-0.0816956-1.0620956-0.0816956-1.0620956 c-0.0817032,0-0.2451019-0.0816994-0.4085007-0.0816994c-0.0817032,0.0816994-0.0817032,0.4901962-0.1634064,0.4901962 c-0.0816956,0,0-0.5718994-0.0816956-0.6535988c-0.0816994,0-0.2450981-0.1633987-0.3268013-0.2450981 c0-0.2450981-0.1633987,0.6535988-0.1633987,0.4902c0-0.0816994,0-0.6535988,0-0.735302 c-0.0816994-0.1633987-0.2451019,0-0.3268013,0.3268013c-0.1634026-0.4902-0.4085007-0.8170013-0.4085007-0.8170013 c0,0.0816994,0.1633987,1.3072014,0.1633987,1.3072014l-0.6535988,0.9804001v0.0816994c0,0,0.4902-0.4901962,0.735302-0.5718994 c0.2450981-0.0816994,0.3268013,0.5718994,0.3268013,0.5718994l0.2450981,0.0816994c0,0,0.1634026-0.2450981,0.3268013-0.3268013 c0.1634026,0,0.0816994,0.4902,0.0816994,0.4902l0.2451019,0.1633987c0,0,0.0816956-0.4902,0.3267975-0.2450981 c0.2451019,0.1633987,0.1633987,0.4901962,0.1633987,0.4901962s0.2451019,0.1634026,0.3267975,0.0816994 c0-0.0816994,0.4902039-0.5718994,0.6536026-0.4901962c0.1633987,0.0816956,0.2451019,0.9804001,0.2451019,0.9804001 l0.1633987,0.1633987c0,0,0.3268051-0.735302,0.4901962-0.6535988c0.1633987,0.0816994,0.2451096,0.735302,0.2451096,0.735302 l0.3267975-0.1634026c0,0,0.1633987,0.0816994,0.1633987,0.1634026c0,0.0816956,0.3267975,0.0816956,0.4901962,0 c0.0816956,0,0.0816956-0.5719032,0.0816956-1.1438026c0,0.6535988,0,1.1438026,0.0817032,1.2254982 c0.1633987,0.0816994,0.4901962,0,0.4901962,0l0.1633987-0.1633987l0.3267975,0.1633987 c0,0,0.0817032-0.7352982,0.2451096-0.7352982c0.1633911-0.0816994,0.4901962,0.6535988,0.4901962,0.6535988l0.1633987-0.1634026 c0,0,0.0816956-0.8986969,0.2451019-0.9804001c0.1633911-0.0816956,0.6536026,0.4902,0.6536026,0.4902 c0,0.0816994,0.3267975-0.0816994,0.3267975-0.0816994s0-0.3268013,0.1633987-0.4901962 c0.2451019-0.1634026,0.3267975,0.2450981,0.3267975,0.2450981l0.2451019-0.1634026c0,0-0.0816956-0.5718994,0.0817032-0.4901962 c0.1633987,0,0.3267975,0.3268013,0.3267975,0.3268013l0.2451019-0.0816994c0,0,0.0817032-0.6535988,0.3268051-0.5718994 s0.7352982,0.5718994,0.7352982,0.5718994v-0.0816994l-0.1633987-0.9804001 C74.3427353,51.4727783,74.5061264,50.3289833,74.5061264,50.2472801z"
      />
      <path
        opacity="0.41"
        d="M63.8034401,48.8583794 c0.1633987-0.5718994,1.6339989-2.9411964,2.2058983-2.9411964c0.4901962,0,0.8169937,0.2451019,1.1437988,0.4902 c0-0.0816994,0-0.0816994-0.0817032-0.1633987c-0.4085007-0.3268013-0.8169937-0.735302-1.3888931-0.735302 s-2.0424995,2.369297-2.2058983,2.9411964c-0.0816994,0.1633987,0.0816956,1.3071976,0.4901962,1.4705963h0.0816994 C63.8034401,49.5936813,63.7217369,48.9400826,63.8034401,48.8583794z"
      />
      <path
        opacity="0.41"
        d="M65.6008377,49.6753807 c0.3267975-0.2450981,1.879097-3.0228996,1.4705963-3.3496971s-0.8169937-0.735302-1.3888931-0.735302 s-2.0424995,2.3693008-2.2058983,2.9412003c-0.0816994,0.1633987,0.0816956,1.3071976,0.4901962,1.4705963 C64.2936401,50.1655807,65.2740326,49.9204826,65.6008377,49.6753807z"
      />
      <path
        opacity="0.41"
        d="M67.2348328,50.7374802l-1.3071976,0.2451019l1.5522995-1.879097 C67.5616379,49.1034851,68.0518341,50.1655807,67.2348328,50.7374802z"
      />
      <polygon
        opacity="0.41"
        points="66.4178314,50.9008789 67.6433334,49.3485832 67.5616379,49.1034851 66.0093384,50.9825821"
      />
      <path
        opacity="0.41"
        d="M63.8034401,48.8583794 c0.1633987-0.5718994,1.6339989-2.9411964,2.2058983-2.9411964c0.4901962,0,0.8169937,0.2451019,1.1437988,0.4902 c0-0.0816994,0-0.0816994-0.0817032-0.1633987c-0.4085007-0.3268013-0.8169937-0.735302-1.3888931-0.735302 s-2.0424995,2.369297-2.2058983,2.9411964c-0.0816994,0.1633987,0.0816956,1.3071976,0.4901962,1.4705963h0.0816994 C63.8034401,49.5936813,63.7217369,48.9400826,63.8034401,48.8583794z"
      />
      <path
        opacity="0.41"
        d="M65.6008377,49.6753807 c0.3267975-0.2450981,1.879097-3.0228996,1.4705963-3.3496971s-0.8169937-0.735302-1.3888931-0.735302 s-2.0424995,2.3693008-2.2058983,2.9412003c-0.0816994,0.1633987,0.0816956,1.3071976,0.4901962,1.4705963 C64.2936401,50.1655807,65.2740326,49.9204826,65.6008377,49.6753807z"
      />
      <path
        opacity="0.41"
        d="M67.2348328,50.7374802l-1.3071976,0.2451019l1.5522995-1.879097 C67.5616379,49.1034851,68.0518341,50.1655807,67.2348328,50.7374802z"
      />
      <polygon
        opacity="0.41"
        points="66.4178314,50.9008789 67.6433334,49.3485832 67.5616379,49.1034851 66.0093384,50.9825821"
      />
      <g>
        <path
          opacity="0.41"
          d="M73.1172333,48.7766838 c-0.1633987-0.5719032-1.6339951-2.9411964-2.2058945-2.9411964c-0.4901962,0-0.8170013,0.2450981-1.1437988,0.4901962 c0-0.0816994,0-0.0816994,0.0816956-0.1633987c0.4085007-0.3268013,0.8170013-0.735302,1.3888931-0.735302 c0.5718994,0,2.0425034,2.3693008,2.2059021,2.9411964c0.0816956,0.1634026-0.0817032,1.3071976-0.4902039,1.4706001h-0.0816956 C73.0355301,49.511982,73.1172333,48.9400826,73.1172333,48.7766838z"
        />
        <path
          opacity="0.41"
          d="M71.2381287,49.5936813 c-0.3267975-0.2450981-1.879097-3.0228996-1.4705963-3.3496971c0.4085007-0.3268013,0.8170013-0.7352982,1.3888931-0.7352982 c0.5718994,0,2.0425034,2.369297,2.2058945,2.9411964c0.0817032,0.1633987-0.0816956,1.3071976-0.4901962,1.4705963 C72.463623,50.0838814,71.5649338,49.8387794,71.2381287,49.5936813z"
        />
      </g>
      <g>
        <path
          opacity="0.41"
          d="M69.6041336,50.6557808l1.3071976,0.2450981l-1.5522995-1.879097 C69.3590317,49.0217819,68.7871323,50.0838814,69.6041336,50.6557808z"
        />
        <polygon
          opacity="0.41"
          points="70.5028305,50.8191795 69.1956329,49.26688 69.3590317,49.0217819 70.8296356,50.9008789"
        />
      </g>
      <g>
        <linearGradient
          id="SVGID_7_"
          gradientUnits="userSpaceOnUse"
          x1="68.377"
          y1="-1184.445"
          x2="68.604"
          y2="-1165.464"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0" stopColor={colors[2]} />
          <stop offset="0" stopColor={colors[3]} stopOpacity="0.936" />
          <stop offset="0" stopColor={colors[4]} stopOpacity="0.89" />
          <stop offset="0.079" stopColor={colors[5]} stopOpacity="0.795" />
          <stop offset="0.191" stopColor={colors[6]} stopOpacity="0.661" />
          <stop offset="0.319" stopColor={colors[7]} stopOpacity="0.507" />
          <stop offset="0.476" stopColor={colors[8]} stopOpacity="0.319" />
          <stop offset="0.742" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="SVGID_8_"
          gradientUnits="userSpaceOnUse"
          x1="68.529"
          y1="-1165.607"
          x2="68.503"
          y2="-1179.6"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0.059" stopColor={colors[2]} />
          <stop offset="0.522" stopColor={colors[10]} stopOpacity="0.383" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_7_)"
          d="M76.385231,52.7799797l-1.7973938-1.2254982c0,0,1.879097-3.2679977,1.1437988-3.2679977 c-1.4706039,0.1634026-1.9608002-0.8169975-2.4509964-1.6339989c-0.0817032-0.0816994-0.0817032-0.2450981-0.1633987-0.3268013 c-0.4085007-0.8169975-0.2451019-2.5326958-0.2451019-2.5326958l-1.225502,0.9804001 c-0.9803925-0.8170013-2.1241989-0.0816994-2.532692-0.1634026l-0.7353058-2.5326958l-0.8170013,2.5326958 c-0.408493,0.0816994-1.4705963-0.7352982-2.4509964,0.1634026l-1.1437988-0.9804001 c0,0,0.2451019,1.6339989-0.1633987,2.3693008c-0.1634026,0.2450981-0.3268013,0.4901962-0.3268013,0.6535988 c-0.2451019,0.8986969-0.5719032,1.879097-2.3693008,1.879097c-0.4902,0,1.1437988,2.8594971,1.1437988,2.8594971 l-1.7973976,1.2254982h1.7973976c0,0.3268013-0.0816994,0.735302,0.0816956,1.0620995 c0.0816994-0.4085007,0.6535988-0.8170013,1.0620995-1.0620995h0.2450981 c-0.0816956,0.2450981-0.0816956,0.5718994,0.1634026,0.8987007c0-0.1634026,0.2451019-0.4085007,0.4085007-0.5719032 c0.0816956,0,0.1633987,0.0816994,0.2450943,0.1634026c0,0.1633987,0.0817032,0.4085007,0.2451019,0.5718994l0.2451019-0.3268013 c0.0816956,0.0816994,0.1633987,0.0816994,0.2451019,0.1634026c0,0.4084969,0,0.8986969,0.2451019,1.3071976 c0.0816956-0.4085007,0.4901962-0.735302,0.7352982-0.8170013h0.0817032c0,0,0.0816956,0,0.0816956,0.0816994 c0,0.3268013,0.0816956,0.8986969,0.4085007,1.1437988c0-0.2450981,0.1633987-0.4901962,0.3267975-0.6535988h2.3693008 c0.1633987,0.1634026,0.3268051,0.4085007,0.3268051,0.6535988c0.3267975-0.1633987,0.408493-0.7352982,0.408493-1.0620956 c0.0817032-0.0816994,0.1633987-0.0816994,0.1633987-0.0816994l0,0c0.2451019,0.1633987,0.6536026,0.4084969,0.7353058,0.8169975 c0.2451019-0.3268013,0.2451019-0.8986969,0.2451019-1.2254982c0.0816956-0.0816994,0.1633987-0.0816994,0.3267975-0.1633987 l0.2451019,0.3267975c0.1633987-0.1633987,0.2451019-0.3267975,0.2451019-0.4901962 c0.0817032-0.0816994,0.2451019-0.0816994,0.3268051-0.1634026c0.1633987,0.1634026,0.4085007,0.4085007,0.4085007,0.5719032 c0.2451019-0.2451019,0.2451019-0.5719032,0.2451019-0.8170013c0.0816956,0,0.0816956-0.0816994,0.1633911-0.0816994h0.0817032 c0.3267975,0.2451019,0.9803925,0.6535988,1.0621033,1.0620995c0.1633911-0.3268013,0.1633911-0.735302,0.0816956-1.0620995 h1.8791046v-0.2451019H76.385231z"
        />
        <path
          fill="url(#SVGID_8_)"
          d="M76.4669266,52.6982803l-1.7973938-1.225502c0,0,1.8791046-3.2679977,1.1437988-3.2679977 c-1.4705963,0.1634026-1.9608002-0.8169975-2.4509964-1.6339989c-0.0816956-0.0816956-0.0816956-0.2450981-0.1633987-0.3267975 c-0.4085007-0.8170013-0.2451019-2.5326996-0.2451019-2.5326996l-1.2254944,0.9804001 c-0.9804001-0.8169975-2.1241989-0.0816994-2.5326996-0.1633987l-0.7352982-2.5326996l-0.8170013,2.5326996 c-0.4085007,0.0816994-1.4706039-0.735302-2.4509964,0.1633987l-1.1438065-0.9804001 c0,0,0.2451019,1.6339989-0.1633987,2.3693008c-0.1633987,0.2450981-0.3268013,0.4901962-0.3268013,0.6535988 c-0.2450981,0.8986969-0.5718994,1.879097-2.369297,1.879097c-0.4902,0,1.1437988,2.8594971,1.1437988,2.8594971 l-1.7973976,1.225502H62.33284c0,0.3267975-0.0816994,0.7352982,0.0816994,1.0620956 c0.0816994-0.4084969,0.6535988-0.8169975,1.0620995-1.0620956h0.2450981 c-0.0816994,0.2450981-0.0816994,0.5718994,0.1634026,0.8986969c0-0.1634026,0.2450943-0.4085007,0.4085007-0.5718994 c0.0816956,0,0.1633987,0.0816994,0.2450943,0.1633987c0,0.1634026,0.0817032,0.4085007,0.2451019,0.5718994l0.2451019-0.3268013 c0.0816956,0.0816994,0.1633987,0.0816994,0.2451019,0.1634026c0,0.4085007,0,0.8986969,0.2451019,1.3071976 c0.0816956-0.4085007,0.4901962-0.735302,0.7352982-0.8170013h0.0816956c0,0,0.0816956,0,0.0816956,0.0816994 c0,0.3268013,0.0817032,0.8987007,0.4085007,1.1438026c0-0.2451019,0.1633987-0.4902,0.3268051-0.6535988h2.4509964 c0.1633987,0.1633987,0.3267975,0.4084969,0.3267975,0.6535988c0.3268051-0.1634026,0.4085007-0.735302,0.4085007-1.0620995 c0.0817032-0.0816994,0.1633987-0.0816994,0.1633987-0.0816994l0,0c0.2451019,0.1634026,0.6536026,0.4085007,0.7352982,0.8170013 c0.2451096-0.3268013,0.2451096-0.8987007,0.2451096-1.225502c0.0816956-0.0816956,0.1633911-0.0816956,0.3267975-0.1633987 l0.2451019,0.3268013c0.1633987-0.1634026,0.2451019-0.3268013,0.2451019-0.4902 c0.0816956-0.0816994,0.2451019-0.0816994,0.3268051-0.1633987c0.1633911,0.1633987,0.408493,0.4085007,0.408493,0.5718994 c0.2451019-0.2450981,0.2451019-0.5718994,0.2451019-0.8170013c0.0817032,0,0.0817032-0.0816956,0.1633987-0.0816956h0.0817032 c0.3267975,0.2450981,0.9803925,0.6535988,1.0620956,1.0620956c0.1633987-0.3267975,0.1633987-0.7352982,0.0817032-1.0620956 h1.7973938C76.4669342,52.9433823,76.4669342,52.6982803,76.4669266,52.6982803z"
        />
        <linearGradient
          id="SVGID_9_"
          gradientUnits="userSpaceOnUse"
          x1="66.824"
          y1="-1181.404"
          x2="66.821"
          y2="-1183.163"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_9_)"
          d="M66.9080353,53.4335785c-0.1633987,0.4902-0.4902039,0.8987007-0.2451019,1.3889008 c0,0.0816994,0.2451019,0.1633987,0.1633911,0c-0.2451019-0.4085007,0.0817032-0.8986969,0.2451096-1.3071976 C67.071434,53.5152779,66.9080353,53.3518791,66.9080353,53.4335785L66.9080353,53.4335785z"
        />
        <linearGradient
          id="SVGID_10_"
          gradientUnits="userSpaceOnUse"
          x1="65.737"
          y1="-1180.719"
          x2="65.733"
          y2="-1182.647"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_10_)"
          d="M65.9276352,53.0250778c-0.4901962,0.4085007-0.4901962,0.9804001-0.5718994,1.5523033 c0,0.0816956,0.1633987,0.1633987,0.1633987,0.1633987c0.0817032-0.5718994,0.0817032-1.1437988,0.5718994-1.4705963 C66.1727371,53.1067772,66.0093384,52.9433784,65.9276352,53.0250778L65.9276352,53.0250778z"
        />
        <linearGradient
          id="SVGID_11_"
          gradientUnits="userSpaceOnUse"
          x1="64.754"
          y1="-1180.718"
          x2="64.752"
          y2="-1181.795"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_11_)"
          d="M64.7021408,52.7799797c-0.0817032,0.2450981-0.0817032,0.4902,0,0.735302 c0,0.0816994,0.1633911,0.1633987,0.1633911,0.0816994c-0.0816956-0.2451019-0.0816956-0.4902,0-0.735302 C64.8655319,52.8616791,64.7021408,52.6982803,64.7021408,52.7799797L64.7021408,52.7799797z"
        />
        <linearGradient
          id="SVGID_12_"
          gradientUnits="userSpaceOnUse"
          x1="63.968"
          y1="-1180.306"
          x2="63.966"
          y2="-1181.437"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_12_)"
          d="M64.0485382,52.616581c-0.2450981,0.2450981-0.3268013,0.4084969-0.3268013,0.7352982 c0,0.0816994,0.1634026,0.1634026,0.1634026,0.1634026c0-0.3268013,0.0816956-0.5718994,0.3267975-0.735302 C64.211937,52.6982803,64.0485382,52.5348778,64.0485382,52.616581L64.0485382,52.616581z"
        />
        <linearGradient
          id="SVGID_13_"
          gradientUnits="userSpaceOnUse"
          x1="62.714"
          y1="-1179.746"
          x2="62.711"
          y2="-1181.548"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_13_)"
          d="M63.1498375,52.0446815c-0.4902,0.2450981-0.8170013,0.7352982-0.9804001,1.3071976 c0,0.0816956,0.1633987,0.1633987,0.1633987,0.1633987c0.0816994-0.5718994,0.4085007-1.0620995,0.8987007-1.3071976 C63.3132362,52.2080803,63.1498375,52.0446815,63.1498375,52.0446815L63.1498375,52.0446815z"
        />
        <linearGradient
          id="SVGID_14_"
          gradientUnits="userSpaceOnUse"
          x1="66.807"
          y1="-1181.245"
          x2="66.804"
          y2="-1183.068"
          gradientTransform="matrix(1 0 0 -1 0 -1128)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_14_)"
          d="M66.9080353,53.5152779c-0.3268051,0.4085007-0.4085007,0.8986969-0.3268051,1.3889008 c0,0.0816994,0.1633987,0.1633987,0.1633987,0.0816994c-0.1633987-0.4902,0-0.9804001,0.2451019-1.3071976 C67.1531372,53.596981,66.9897385,53.4335785,66.9080353,53.5152779L66.9080353,53.5152779z"
        />
        <g>
          <linearGradient
            id="SVGID_15_"
            gradientUnits="userSpaceOnUse"
            x1="66.756"
            y1="-1181.327"
            x2="66.753"
            y2="-1183.174"
            gradientTransform="matrix(1 0 0 -1 0 -1128)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_15_)"
            d="M66.8263321,53.596981c-0.3267975,0.4084969-0.4085007,0.8986969-0.1633987,1.3888969 c0,0.0816994,0.1633987,0.1634026,0.1633987,0.0816994c-0.1633987-0.4085007-0.0816956-0.8986969,0.1633987-1.3071976 C66.9897385,53.6786804,66.8263321,53.5152779,66.8263321,53.596981L66.8263321,53.596981z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_16_"
            gradientUnits="userSpaceOnUse"
            x1="65.67"
            y1="-1180.759"
            x2="65.666"
            y2="-1182.732"
            gradientTransform="matrix(1 0 0 -1 0 -1128)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_16_)"
            d="M65.8459396,53.0250778c-0.4085007,0.4085007-0.6536026,0.9804001-0.4902039,1.5523033 c0,0.0816956,0.1633987,0.1633987,0.1633987,0.0816956c-0.0816956-0.5718994,0.0817032-1.0620956,0.4902039-1.4705963 C66.0910339,53.1884804,65.9276352,53.0250778,65.8459396,53.0250778L65.8459396,53.0250778z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_17_"
            gradientUnits="userSpaceOnUse"
            x1="65.683"
            y1="-1180.767"
            x2="65.68"
            y2="-1182.234"
            gradientTransform="matrix(1 0 0 -1 0 -1128)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_17_)"
            d="M65.8459396,53.1067772c-0.1633987,0.0816994-0.3268051,0.2451019-0.4085007,0.4085007 c-0.0817032,0.1634026,0,0.4085007,0,0.6535988c0,0.0816994,0.1633987,0.1634026,0.1633987,0.0816994 c0-0.2450981-0.0817032-0.4902,0-0.6535988c0.0816956-0.1634026,0.2451019-0.2450981,0.3267975-0.3268013 C66.0093384,53.1884804,65.9276352,53.0250778,65.8459396,53.1067772L65.8459396,53.1067772z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_18_"
            gradientUnits="userSpaceOnUse"
            x1="64.789"
            y1="-1180.531"
            x2="64.787"
            y2="-1181.931"
            gradientTransform="matrix(1 0 0 -1 0 -1128)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_18_)"
            d="M64.7838364,52.8616791c-0.2451019,0.2450981-0.1633987,0.5718994,0,0.8170013 c0.0816956,0.0816956,0.1633987,0.0816956,0.0816956-0.0816994c-0.1633987-0.1634026-0.0816956-0.4085007,0.0817032-0.5719032 C64.9472427,52.9433784,64.7838364,52.7799797,64.7838364,52.8616791L64.7838364,52.8616791z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_19_"
            gradientUnits="userSpaceOnUse"
            x1="64.731"
            y1="-1180.443"
            x2="64.729"
            y2="-1181.943"
            gradientTransform="matrix(1 0 0 -1 0 -1128)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_19_)"
            d="M64.7021408,52.7799797c-0.3268051,0.2450981-0.1634064,0.5718994,0,0.8987007 c0,0.0816956,0.2451019,0.1633987,0.1633911,0c-0.1633987-0.2451019-0.2450943-0.5719032,0.0817032-0.735302 C64.9472427,52.9433784,64.7838364,52.7799797,64.7021408,52.7799797L64.7021408,52.7799797z"
          />
          <g>
            <linearGradient
              id="SVGID_20_"
              gradientUnits="userSpaceOnUse"
              x1="63.999"
              y1="-1180.128"
              x2="63.996"
              y2="-1181.578"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_20_)"
              d="M64.1302338,52.4531784c-0.3267975,0.1634026-0.4901962,0.4902-0.4084969,0.8170013 c0,0.0816994,0.1634026,0.1633987,0.1634026,0.0816994c-0.0816994-0.3268013,0.0816956-0.6535988,0.4085007-0.8170013 C64.2936401,52.616581,64.211937,52.4531784,64.1302338,52.4531784L64.1302338,52.4531784z"
            />
            <linearGradient
              id="SVGID_21_"
              gradientUnits="userSpaceOnUse"
              x1="63.965"
              y1="-1180.245"
              x2="63.962"
              y2="-1181.852"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_21_)"
              d="M64.0485382,52.5348778c-0.3268013,0.2450981-0.4085007,0.6535988-0.3268013,1.0620995 c0,0.0816994,0.1634026,0.1633987,0.1634026,0.0816994c-0.1634026-0.4085007,0-0.735302,0.3267975-0.9804001 C64.2936401,52.6982803,64.1302338,52.5348778,64.0485382,52.5348778L64.0485382,52.5348778z"
            />
            <linearGradient
              id="SVGID_22_"
              gradientUnits="userSpaceOnUse"
              x1="62.774"
              y1="-1179.708"
              x2="62.77"
              y2="-1182.088"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_22_)"
              d="M63.1498375,52.1263771c-0.4085007-0.0816956-0.735302,0.3268013-0.8170013,0.6535988 c-0.0816956,0.2451019-0.0816956,0.6535988,0.0816994,0.8987007 c0.0816994,0.0816994,0.1634026,0.0816994,0.0816994-0.0816994c-0.0816994-0.0816994,0-0.6535988,0-0.735302 c0.0816994-0.2450981,0.4085007-0.6535988,0.735302-0.5718994 C63.3132362,52.2897797,63.2315407,52.1263771,63.1498375,52.1263771L63.1498375,52.1263771z"
            />
            <linearGradient
              id="SVGID_23_"
              gradientUnits="userSpaceOnUse"
              x1="62.899"
              y1="-1179.9"
              x2="62.896"
              y2="-1181.719"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_23_)"
              d="M63.1498375,52.2897797c-0.4902,0.2450981-0.735302,0.7352982-0.6535988,1.3071976 c0,0.0816994,0.1633987,0.1633987,0.1633987,0.0816994c-0.0816994-0.5718994,0.1634026-0.9804001,0.6535988-1.225502 C63.3132362,52.4531784,63.2315407,52.2080803,63.1498375,52.2897797L63.1498375,52.2897797z"
            />
            <linearGradient
              id="SVGID_24_"
              gradientUnits="userSpaceOnUse"
              x1="62.801"
              y1="-1179.647"
              x2="62.798"
              y2="-1181.482"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_24_)"
              d="M63.2315407,51.9629822c-0.2451019,0.0816994-0.5719032,0.2450981-0.735302,0.4901962 c-0.2450981,0.2451019-0.2450981,0.5718994-0.2450981,0.8987007c0,0.0816956,0.1633987,0.1633987,0.1633987,0.1633987 c0-0.3268013,0-0.6535988,0.1633987-0.8986969c0.1634026-0.2451019,0.4902-0.3268013,0.735302-0.4085007 C63.3949394,52.1263771,63.3132362,51.9629822,63.2315407,51.9629822L63.2315407,51.9629822z"
            />
            <linearGradient
              id="SVGID_25_"
              gradientUnits="userSpaceOnUse"
              x1="70.053"
              y1="-1181.172"
              x2="70.049"
              y2="-1183.151"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_25_)"
              d="M69.8492355,53.5152779c0.3267975,0.4085007,0.3267975,0.8986969,0.0816956,1.3071976 c0,0.0816994,0.1633987,0.2450981,0.1633987,0.1634026C70.4211349,54.4956779,70.3394318,53.9237785,69.8492355,53.5152779 C69.8492355,53.3518791,69.7675323,53.4335785,69.8492355,53.5152779L69.8492355,53.5152779z"
            />
            <linearGradient
              id="SVGID_26_"
              gradientUnits="userSpaceOnUse"
              x1="70.036"
              y1="-1181.299"
              x2="70.032"
              y2="-1183.266"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_26_)"
              d="M69.8492355,53.596981c0.3267975,0.4084969,0.3267975,0.8986969,0.0816956,1.3888969 c0,0.0816994,0.1633987,0.1634026,0.1633987,0.1634026c0.2451019-0.4902,0.1633987-1.0620995-0.0816956-1.5522995 C69.9309311,53.5152779,69.7675323,53.4335785,69.8492355,53.596981L69.8492355,53.596981z"
            />
            <linearGradient
              id="SVGID_27_"
              gradientUnits="userSpaceOnUse"
              x1="71.048"
              y1="-1180.663"
              x2="71.044"
              y2="-1182.688"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_27_)"
              d="M70.8296356,53.0250778c0.408493,0.4085007,0.3267975,1.0620995,0.3267975,1.5523033 c0,0.0816956,0.1633987,0.1633987,0.1633987,0.1633987C71.3198318,54.0871773,71.4015274,53.5152779,70.8296356,53.0250778 C70.7479324,52.8616791,70.7479324,52.9433784,70.8296356,53.0250778L70.8296356,53.0250778z"
            />
            <linearGradient
              id="SVGID_28_"
              gradientUnits="userSpaceOnUse"
              x1="71.214"
              y1="-1180.72"
              x2="71.21"
              y2="-1182.674"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_28_)"
              d="M71.0747375,53.2701797c0.3267975,0.1633987,0.0816956,0.9804001,0.0816956,1.2254982 c0,0.0816994,0.1633987,0.1633987,0.1633987,0.1633987c0.1633987-0.4901962,0.3267975-1.3071976-0.3268051-1.5522995 C70.9113312,53.1067772,70.9930267,53.2701797,71.0747375,53.2701797L71.0747375,53.2701797z"
            />
            <linearGradient
              id="SVGID_29_"
              gradientUnits="userSpaceOnUse"
              x1="71.146"
              y1="-1180.778"
              x2="71.144"
              y2="-1182.014"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_29_)"
              d="M70.9113312,53.1067772c0.2451019,0.2451019,0.3267975,0.4902,0.3267975,0.8170013 c0,0.0816994,0.1633987,0.1633987,0.1633987,0.1633987C71.4015274,53.6786804,71.2381287,53.4335785,70.9113312,53.1067772 C70.9930267,53.0250778,70.8296356,52.9433784,70.9113312,53.1067772L70.9113312,53.1067772z"
            />
            <linearGradient
              id="SVGID_30_"
              gradientUnits="userSpaceOnUse"
              x1="72.154"
              y1="-1180.776"
              x2="72.152"
              y2="-1181.973"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_30_)"
              d="M72.05513,52.9433784c0.0817032,0.2450981,0,0.4901962-0.0816956,0.6535988 c0,0.0816994,0.1633987,0.2450981,0.1633987,0.1633987c0.1633911-0.2450981,0.2451019-0.4084969,0.1633911-0.7352982 C72.1368332,52.9433784,71.9734344,52.8616791,72.05513,52.9433784L72.05513,52.9433784z"
            />
            <linearGradient
              id="SVGID_31_"
              gradientUnits="userSpaceOnUse"
              x1="72.925"
              y1="-1180.199"
              x2="72.922"
              y2="-1181.432"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_31_)"
              d="M72.8721313,52.5348778L72.8721313,52.5348778 C72.7904358,52.5348778,72.7904358,52.5348778,72.8721313,52.5348778c0,0.2450981,0,0.4902,0,0.735302 c0,0.0816994,0.1633987,0.1633987,0.1633987,0.1633987c0-0.2450981,0-0.4085007-0.0817032-0.6535988 c0-0.0816994-0.0816956-0.0816994,0-0.0816994C73.0355301,52.6982803,72.9538269,52.5348778,72.8721313,52.5348778 L72.8721313,52.5348778z"
            />
            <linearGradient
              id="SVGID_32_"
              gradientUnits="userSpaceOnUse"
              x1="74.04"
              y1="-1179.782"
              x2="74.037"
              y2="-1181.477"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_32_)"
              d="M73.7708282,52.2080803c0.3268051,0.2450981,0.3268051,0.6535988,0.4085007,1.0620995 c0,0.0816994,0.1633987,0.1633987,0.1633987,0.0816994c-0.0817032-0.5719032-0.1633987-0.9804001-0.5718994-1.3071976 C73.6891327,52.0446815,73.7708282,52.2080803,73.7708282,52.2080803L73.7708282,52.2080803z"
            />
            <linearGradient
              id="SVGID_33_"
              gradientUnits="userSpaceOnUse"
              x1="74.21"
              y1="-1180.039"
              x2="74.208"
              y2="-1181.195"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_33_)"
              d="M74.0159302,52.2897797c0.1633987,0.2450981,0.2451019,0.4901962,0.2451019,0.8169975 c0,0.0816994,0.1633987,0.1634026,0.1633987,0.1634026c0-0.3268013-0.0816956-0.6535988-0.2451019-0.8987007 C74.0976334,52.2897797,73.9342346,52.2080803,74.0159302,52.2897797L74.0159302,52.2897797z"
            />
            <linearGradient
              id="SVGID_34_"
              gradientUnits="userSpaceOnUse"
              x1="74.333"
              y1="-1180.224"
              x2="74.331"
              y2="-1181.146"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_34_)"
              d="M74.1793289,52.4531784c0.0816956,0.1634026,0.1633987,0.3268013,0.1633987,0.5718994 c0,0.0816994,0.1633987,0.1634026,0.1633987,0.1634026c0-0.2450981-0.0817032-0.4085007-0.1633987-0.6535988 C74.2610245,52.4531784,74.0976334,52.371479,74.1793289,52.4531784L74.1793289,52.4531784z"
            />
            <linearGradient
              id="SVGID_35_"
              gradientUnits="userSpaceOnUse"
              x1="66.642"
              y1="-1173.226"
              x2="66.633"
              y2="-1177.912"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_35_)"
              d="M66.4178314,45.6720848c0.4085007,0.3268013,0.7353058,0.6535988,0.6536026,1.1438026 c-0.0816956,0.3267975-0.2451019,0.6535988-0.3267975,0.9803963 c-0.2451019,0.6536026-0.4901962,1.3072014-0.7352982,1.8791008c0,0.0816994,0.1633911,0.2450981,0.1633911,0.1633987 c0.3268051-0.9804001,0.8170013-1.9608002,1.0621033-2.9411964 C67.3982391,46.3256836,66.8263321,45.9171829,66.4178314,45.6720848 C66.3361359,45.4269867,66.3361359,45.5903816,66.4178314,45.6720848L66.4178314,45.6720848z"
            />
            <linearGradient
              id="SVGID_36_"
              gradientUnits="userSpaceOnUse"
              x1="69.991"
              y1="-1173.019"
              x2="69.983"
              y2="-1176.933"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_36_)"
              d="M70.5028305,45.3452835c-0.4901962,0.3268013-1.1437988,0.5718994-1.1437988,1.3071976 c0.0816956,0.735302,0.7352982,1.3889008,0.5718994,2.0424995c0,0.0816994,0.1633911,0.1633987,0.1633911,0.1633987 c0.0817032-0.5718994-0.3267975-1.1437988-0.4901962-1.6339989 c-0.1633987-0.4084969-0.1633987-0.8169975,0.1633987-1.1437988 c0.2451019-0.2450981,0.5718994-0.4085007,0.8170013-0.5718994 C70.6662369,45.5086861,70.5845337,45.2635841,70.5028305,45.3452835L70.5028305,45.3452835z"
            />
            <linearGradient
              id="SVGID_37_"
              gradientUnits="userSpaceOnUse"
              x1="67.552"
              y1="-1176.446"
              x2="67.55"
              y2="-1177.68"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_37_)"
              d="M67.3982391,49.1851807c0.0816956-0.0816956,0.0816956-0.1633987,0.1633987-0.0816956 c0.0816956,0,0.1633911,0.3267975,0.1633911,0.3267975c0,0.0816994,0.1633987,0.1634026,0.1633987,0.0816994 c-0.0816956-0.1633987-0.1633987-0.4901962-0.3267975-0.6535988c-0.1633987-0.1633987-0.2451019,0-0.3268051,0.1634026 C67.1531372,49.1034851,67.3165359,49.26688,67.3982391,49.1851807L67.3982391,49.1851807z"
            />
            <linearGradient
              id="SVGID_38_"
              gradientUnits="userSpaceOnUse"
              x1="69.255"
              y1="-1176.513"
              x2="69.253"
              y2="-1177.694"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_38_)"
              d="M69.6041336,49.1851807c-0.0816956-0.0816956-0.1633987-0.2450981-0.3267975-0.2450981 c-0.2451096-0.0816994-0.3268051,0.2450981-0.4085007,0.4902c0,0.0816956,0.1633911,0.2450981,0.1633911,0.1633987 c0.0817032-0.0816994,0.2451096-0.6535988,0.4902039-0.4085007 C69.6041336,49.26688,69.6858292,49.26688,69.6041336,49.1851807L69.6041336,49.1851807z"
            />
            <linearGradient
              id="SVGID_39_"
              gradientUnits="userSpaceOnUse"
              x1="62.252"
              y1="-1176.253"
              x2="62.251"
              y2="-1177.067"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_40_"
              gradientUnits="userSpaceOnUse"
              x1="61.669"
              y1="-1179.634"
              x2="61.667"
              y2="-1180.727"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_41_"
              gradientUnits="userSpaceOnUse"
              x1="64.541"
              y1="-1173.47"
              x2="64.537"
              y2="-1175.927"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_42_"
              gradientUnits="userSpaceOnUse"
              x1="72.827"
              y1="-1174.246"
              x2="72.824"
              y2="-1176.236"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_43_"
              gradientUnits="userSpaceOnUse"
              x1="64.458"
              y1="-1171.841"
              x2="64.455"
              y2="-1173.317"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_44_"
              gradientUnits="userSpaceOnUse"
              x1="68.291"
              y1="-1170.248"
              x2="68.286"
              y2="-1172.792"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_45_"
              gradientUnits="userSpaceOnUse"
              x1="72.056"
              y1="-1171.876"
              x2="72.054"
              y2="-1173.253"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_46_"
              gradientUnits="userSpaceOnUse"
              x1="74.688"
              y1="-1176.13"
              x2="74.687"
              y2="-1176.685"
              gradientTransform="matrix(1 0 0 -1 0 -1128)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_47_"
              gradientUnits="userSpaceOnUse"
              x1="-2300.756"
              y1="-1179.54"
              x2="-2300.758"
              y2="-1180.634"
              gradientTransform="rotate(180 -1112.834 -564)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_39_)"
              d="M63.1498375,48.5315819L63.1498375,48.5315819 c-0.0816994,0-0.0816994-0.0816956-0.1634026-0.0816956l0,0c0,0-0.0816956-0.1634026-0.1633987-0.1634026 c-0.4902,0.2450981-1.0620995,0.4902-1.6339989,0.6535988c-0.0816994,0,0.0816994,0.1634026,0.1633987,0.1634026 c0.1634026,0,0.2451019-0.0816994,0.4085007-0.0816994c0,0.0816994,0.0816994,0.1633987,0.1634026,0.1633987h0.0816956 c0,0,0,0,0.0816994,0s0.0816994,0,0.1634026-0.0816994c0.3268013-0.0816956,0.7352982-0.1633987,1.0620995-0.2450981 C63.3949394,48.6949844,63.2315407,48.5315819,63.1498375,48.5315819z"
            />
            <path
              fill="url(#SVGID_40_)"
              d="M62.2511406,52.0446815C62.2511406,52.0446815,62.3328362,52.0446815,62.2511406,52.0446815 c0.0816956-0.0816994,0.0816956-0.1634026,0-0.2451019c0,0,0,0,0.0816956,0c0,0-0.0816956-0.2450981-0.1633987-0.1633987 c-0.3268013,0.1633987-0.6535988,0.4085007-0.9804001,0.5718994v0.0816994 c-0.0816994,0-0.1633987,0.0816994-0.2450981,0.0816994s0.0816994,0.1633987,0.1633987,0.1633987 s0.1634026-0.0816994,0.2450981-0.0816994c-0.0816956,0-0.1633987,0.0816994-0.1633987,0.0816994 s0.0816994,0.1634026,0.1633987,0.1634026c0.3268013-0.1634026,0.735302-0.3268013,1.0620995-0.5719032 C62.4145393,52.1263771,62.3328362,52.0446815,62.2511406,52.0446815z"
            />
            <path
              fill="url(#SVGID_41_)"
              d="M65.3557358,45.5086861c-0.8169937,0.5718994-1.3071976,1.3888969-1.7973976,2.2875977 c0,0.0816956,0.1634026,0.2450981,0.1634026,0.1633987c0.4901962-0.8169975,0.9804001-1.7156982,1.7973938-2.2875977 C65.5191345,45.5903816,65.3557358,45.4269867,65.3557358,45.5086861z"
            />
            <path
              fill="url(#SVGID_42_)"
              d="M73.4440308,48.123085c-0.2451019-0.3268013-0.3268051-0.735302-0.5718994-1.0620995 c-0.1633987-0.2450981-0.3268051-0.4902-0.5718994-0.735302c-0.0816956-0.0816994-0.1633987-0.1633987-0.0816956,0 c0.2451019,0.3268013,0.4901962,0.6535988,0.6536026,1.0620995c0.0816956,0.2450981,0.2451019,0.4901962,0.4085007,0.735302 C73.3623276,48.2047806,73.5257339,48.2864838,73.4440308,48.123085z"
            />
            <path
              fill="url(#SVGID_43_)"
              d="M64.7838364,44.9367828c0,0-0.0816956-0.1633987-0.1633987-0.1633987 c0-0.0816994,0.0816956-0.1633987,0.0816956-0.2450981s-0.1633987-0.2451019-0.1633987-0.1634026 c-0.0817032,0.0816994-0.1633987,0.2451019-0.1633987,0.3268013c0-0.1633987,0-0.3268013,0.0816956-0.4901962 c0-0.0816994-0.1633987-0.1634026-0.1633987-0.1634026c0,0.0816994,0,0.0816994,0,0.1634026 c0-0.0816994,0-0.1634026,0-0.2451019c0-0.0816956-0.1633987-0.1633987-0.1633987-0.0816956 c0.0816956,0.3267975,0.0816956,0.6535988,0.0816956,0.9803963c0,0.0816994-0.0816956,0.2451019-0.0816956,0.3268013 s0.1633987,0.1634026,0.1633987,0.1634026l0,0c0.0816956,0,0.0816956,0.0816994,0.0816956,0.0816994 c0-0.0816994,0-0.0816994,0-0.1634026l0,0l0,0l0.0817032,0.0816994l0.0816956-0.0816994l0,0 C64.7021408,45.018486,64.7838364,44.9367828,64.7838364,44.9367828z"
            />
            <path
              fill="url(#SVGID_44_)"
              d="M68.4603348,44.3648834c-0.0817032,0-0.1633987,0.0816994-0.1633987,0.0816994 c0.1633987-0.1633987,0.3267975-0.2450981,0.4901962-0.4085007c0.0817032-0.0816956-0.1633987-0.2450981-0.1633987-0.1633987 c-0.0816956,0.0816994-0.1633911,0.1633987-0.2451019,0.2450981l0.4085007-0.4901962 c0-0.0816994-0.1633987-0.2451019-0.1633987-0.1634026c-0.0816956,0.1634026-0.2451019,0.2450981-0.3267975,0.4085007 c0.0816956-0.0816994,0.1633987-0.2450981,0.1633987-0.3268013c0.0816956-0.1634026,0.1633987-0.3268013,0.0816956-0.4902 c0,0,0,0-0.0816956-0.0816956c0.0816956-0.1634026,0-0.2451019,0.0816956-0.4902 c0-0.0816994-0.0816956-0.3268013-0.0816956-0.2450981c-0.1633987,0.4901962-0.3268051,1.0620956-0.4902039,1.6339989 c-0.0816956,0.1633987-0.0816956,0.3268013-0.1633911,0.4901962c0,0.0816994-0.0817032,0.1634026,0,0.1634026v0.0816994 c0,0.0816956,0.1633911,0.1633987,0.1633911,0.1633987v-0.0816994c0,0.0816994,0.0817032,0.0816994,0.0817032,0.0816994 c0.1633987-0.0816994,0.4085007-0.1633987,0.5718994-0.2450981 C68.6237335,44.528286,68.5420303,44.3648834,68.4603348,44.3648834z"
            />
            <path
              fill="url(#SVGID_45_)"
              d="M72.5453262,44.2831841c0.0817032-0.0816956,0.1633987-0.1633987,0.2451096-0.2450981 c0.0816956,0-0.0817032-0.2450981-0.1633987-0.1633987c-0.4085007,0.4084969-0.8986969,0.8169975-1.3071976,1.2254982 c-0.0817032,0.0816994,0.0816956,0.2450981,0.1633987,0.1633987c0.0816956-0.0816956,0.2451019-0.2450981,0.3267975-0.3268013 l0.0816956,0.0816994c0,0,0,0,0.0817032,0c0,0,0.0816956,0.1634026,0.1633987,0.1634026 c0,0-0.0817032-0.1634026-0.1633987-0.1634026c0.1633987-0.0816994,0.3267975-0.1633987,0.4901962-0.1633987 c0,0-0.0816956-0.1634026-0.1633987-0.1634026l0,0c0.0817032-0.0816956,0.2451019-0.1633987,0.3268051-0.1633987 C72.6270294,44.3648834,72.6270294,44.3648834,72.5453262,44.2831841z"
            />
            <path
              fill="url(#SVGID_46_)"
              d="M75.7316284,48.2864838c-0.0816956,0.0816994,0,0.0816994-0.1633987,0.0816994 c0,0,0,0-0.0816956,0c0,0,0,0-0.0817032,0c-0.0816956,0-0.2451019,0-0.3267975,0c-0.3268051,0-0.7352982,0-1.0621033-0.2450981 c-0.0816956-0.0816994,0,0.0816956,0.0817032,0.1633987c-0.1633987,0-0.2451019-0.0816994-0.4085007-0.0816994 c-0.0817032,0,0,0.0816994,0,0.0816994s0,0-0.0817032,0l0,0l0,0c0,0.0816994,0.1633987,0.1634026,0.1633987,0.1634026 c0,0.0816956,0.6536026,0.1633987,0.8170013,0.1633987c0.3267975,0,0.6536026,0,0.9803925-0.1633987 c0.1633987,0,0.0817032,0,0.1633987-0.0816994C75.813324,48.3681831,75.7316284,48.2047806,75.7316284,48.2864838z"
            />
            <path
              fill="url(#SVGID_47_)"
              d="M74.5061264,51.9629822C74.5061264,51.9629822,74.4244308,51.9629822,74.5061264,51.9629822 c-0.0816956-0.0816994-0.0816956-0.1634026,0-0.2451019c0,0,0,0-0.0816956,0c0,0,0.0816956-0.2450981,0.1633987-0.1633987 c0.3267975,0.1633987,0.6536026,0.4085007,0.9803925,0.5718994v0.0816994c0.0817032,0,0.1633987,0.0816994,0.2451019,0.0816994 s-0.0816956,0.1633987-0.1633911,0.1633987c-0.0817032,0-0.1633987-0.0816994-0.2451019-0.0816994 c0.0816956,0,0.1633911,0.0816994,0.1633911,0.0816994s-0.0816956,0.1634026-0.1633911,0.1634026 c-0.3268051-0.1634026-0.7353058-0.3268013-1.0621033-0.5718994 C74.3427353,52.0446815,74.4244308,51.9629822,74.5061264,51.9629822z"
            />
          </g>
        </g>
      </g>
      <linearGradient
        id="SVGID_6_"
        gradientUnits="userSpaceOnUse"
        x1="68.346"
        y1="-1182.32"
        x2="68.509"
        y2="-1175.718"
        gradientTransform="matrix(1 0 0 -1 0 -1128)"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.742" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </g>
  )
}

export default DragonSkull
